/** Two specialists, four students, three rounds: the gate-test shape (spec section 12). */
export const GATE_FIXTURE = {
    participants: `participant_id,display_name,role,email
SPEC01,Dr Alice Cardio,specialist,alice@example.org
SPEC02,Mr Ben Surgeon,specialist,
STU01,Carla Student,student,
STU02,Dev Student,student,
STU03,Eve Student,student,
STU04,Finn Student,student,
`,
    rooms: `room_id,room_name,capacity
CARDIOLOGY,Cardiology,4
SURGERY,Surgery,4
`,
    rounds: `round_id,sequence,duration_minutes,planned_start
R1,1,10,2026-11-20T18:00:00+00:00
R2,2,10,2026-11-20T18:12:00+00:00
R3,3,10,2026-11-20T18:24:00+00:00
`,
    assignments: `round_id,participant_id,destination_room_id
R1,SPEC01,CARDIOLOGY
R1,SPEC02,SURGERY
R1,STU01,CARDIOLOGY
R1,STU02,CARDIOLOGY
R1,STU03,SURGERY
R1,STU04,SURGERY
R2,SPEC01,CARDIOLOGY
R2,SPEC02,SURGERY
R2,STU01,SURGERY
R2,STU02,SURGERY
R2,STU03,CARDIOLOGY
R2,STU04,CARDIOLOGY
R3,SPEC01,CARDIOLOGY
R3,SPEC02,SURGERY
R3,STU01,CARDIOLOGY
R3,STU02,MAIN
R3,STU03,SURGERY
R3,STU04,MAIN
`,
};
//# sourceMappingURL=fixtures.js.map